import { createCachedSelector, defaultKeySelector } from '@cbridge-utils/redux';
import { createDefaultCachedSelectorOptions } from '@cbridge-utils/reselect';
import { rulesValidityFilterSelector } from './rulesValidityFilter.selector';

export const rulesValidityFilterHasItemsSelector = createCachedSelector(
  [rulesValidityFilterSelector],
  (validityFilter) => Object.values(validityFilter).some((state) => state?.count > 0 || !!state?.isActive),
)({
  ...createDefaultCachedSelectorOptions(),
  keySelector: defaultKeySelector,
});
